export default {
    "results": {
        "viewTitle": "View: {text}",
        "unselectableViewDisplay": "<Other>",
        "resultsListView": {
            "display": "List",
            "selectDocument": "Select document",
            "unselectDocument": "Unselect document",
            "previewPopup": "Document Navigator",
            "previewInCurrentPage": "Document Navigator (in current page)",
            "previewInNewTab": "Document Navigator (in new tab)",
            "showMetadata": "Details",
            "showLabels": "Labels"
        },
        "resultsGridView": {
            "display": "Grid",
            "selectDocument": "Select document",
            "unselectDocument": "Unselect document",
            "selectDocuments": "Select documents",
            "unselectDocuments": "Unselect documents"
        },
        "viewPageSize": "Number of results per page",
        "viewUpdateApply": "Apply",
        "warningNoViewForTab": "The '{tab}' tab has no associated result views.",
        "warningCannotDisplayTabOnView": "The '{tab}' tab cannot be displayed using '{view}' view because it is not included in the view configuration.",

        "resultsAllTab": "All",
        "resultsTextTab": "Text",
        "results_all_tab": "All",
        "results_text_tab": "Text",
    }
};
